<template>
  <div>
    <vca-column
      class="event-card"
      :class="
        'event-' + event.type_of_event + ' event-' + event.event_state.state
      "
    >
      <div class="event-title">
        <p class="event-subtitle">
          {{ expandedEvent.type_of_event_translation }}
        </p>
        <vca-row class="top-row">
          <h3 class="title">{{ event.name }}</h3>
          <div class="vca-right top-row-meta">
            <svg
              class="card-icon"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                v-if="expandedEvent.type_of_event === 'concert'"
                d="M1.75706 20.7175C0.813225 19.7783 0.341309 18.6553 0.341309 17.3485C0.341309 16.0415 0.813225 14.9161 1.75706 13.9723C2.70089 13.0284 3.82389 12.5565 5.12606 12.5565C5.44356 12.5565 5.73889 12.5768 6.01206 12.6175C6.28523 12.658 6.56023 12.7213 6.83706 12.8075V5.20751C6.83706 4.81768 6.96189 4.4831 7.21156 4.20377C7.46106 3.92443 7.78081 3.7551 8.17081 3.69577L19.9186 2.11627C20.3846 2.05693 20.7911 2.18176 21.1381 2.49076C21.4852 2.79976 21.6588 3.18726 21.6588 3.65326V15.3413C21.6588 16.6529 21.1869 17.7783 20.2431 18.7175C19.2992 19.6565 18.1738 20.126 16.8668 20.126C15.56 20.126 14.437 19.6565 13.4978 18.7175C12.5586 17.7783 12.0891 16.6553 12.0891 15.3485C12.0891 14.0415 12.5586 12.9161 13.4978 11.9723C14.437 11.0284 15.5624 10.5565 16.8741 10.5565C17.1914 10.5565 17.4843 10.5768 17.7528 10.6175C18.0213 10.658 18.2986 10.7213 18.5848 10.8075V7.54776L9.91106 8.66401V17.3413C9.91106 18.6529 9.44148 19.7783 8.50231 20.7175C7.56314 21.6565 6.44014 22.126 5.13331 22.126C3.82631 22.126 2.70089 21.6565 1.75706 20.7175Z"
                fill="currentColor"
              />
              <path
                v-if="expandedEvent.type_of_event === 'festival'"
                d="M6.43472 18.1208V14.199L1.36197 6.58478C1.01481 6.07611 0.987473 5.55311 1.27997 5.01578C1.57231 4.47844 2.02281 4.20978 2.63147 4.20978H13.312C13.9206 4.20978 14.3711 4.47844 14.6635 5.01578C14.956 5.55311 14.9286 6.07611 14.5815 6.58478L9.50872 14.199V18.1208H10.0075C10.4308 18.1208 10.7928 18.2688 11.0935 18.5648C11.3941 18.8608 11.5445 19.2227 11.5445 19.6505C11.5445 20.0785 11.3941 20.4429 11.0935 20.7435C10.7928 21.0442 10.4308 21.1945 10.0075 21.1945H5.93572C5.51256 21.1945 5.15064 21.0442 4.84997 20.7435C4.54931 20.4429 4.39897 20.0785 4.39897 19.6505C4.39897 19.2227 4.54931 18.8608 4.84997 18.5648C5.15064 18.2688 5.51256 18.1208 5.93572 18.1208H6.43472ZM6.47497 8.98053H9.46847L10.65 7.28378H5.30772L6.47497 8.98053ZM13.8425 20.1208C13.1265 19.4048 12.7685 18.5377 12.7685 17.5195C12.7685 16.5015 13.1265 15.6392 13.8425 14.9325C14.5583 14.226 15.4253 13.8728 16.4435 13.8728C16.5296 13.8728 16.6216 13.8704 16.7195 13.8658C16.8173 13.8611 16.9162 13.8671 17.0162 13.8838V5.74678C17.0162 5.31411 17.1666 4.94978 17.4675 4.65378C17.7681 4.35778 18.1301 4.20978 18.5532 4.20978H21.0175C21.6355 4.20978 22.1602 4.42319 22.5917 4.85003C23.0234 5.27686 23.2392 5.79936 23.2392 6.41753C23.2392 7.03553 23.0234 7.56028 22.5917 7.99178C22.1602 8.42344 21.6355 8.63928 21.0175 8.63928H20.0902V17.5195C20.0902 18.5377 19.737 19.4048 19.0305 20.1208C18.324 20.8366 17.4616 21.1945 16.4435 21.1945C15.4253 21.1945 14.5583 20.8366 13.8425 20.1208Z"
                fill="currentColor"
              />
              <path
                v-if="expandedEvent.type_of_event === 'stadium'"
                d="M12.6228 22.0467V17.1847L11.1565 15.7685L10.5663 18.4042C10.4641 18.8109 10.2419 19.1325 9.89954 19.369C9.55704 19.6056 9.17788 19.6823 8.76204 19.599L3.81429 18.588C3.41929 18.5046 3.11288 18.3012 2.89504 17.9777C2.67738 17.6542 2.61021 17.295 2.69354 16.9C2.77688 16.5145 2.98263 16.2123 3.31079 15.9935C3.63913 15.7746 4.00079 15.7069 4.39579 15.7902L7.85429 16.501L9.26954 9.36523L8.25004 9.78047V11.9457C8.25004 12.3501 8.11146 12.6885 7.83429 12.961C7.55713 13.2333 7.21871 13.3695 6.81904 13.3695C6.41938 13.3695 6.08096 13.2309 5.80379 12.9537C5.52663 12.6766 5.38804 12.3358 5.38804 11.9315V8.94448C5.38804 8.63081 5.47721 8.34264 5.65554 8.07998C5.83371 7.81714 6.06304 7.62631 6.34354 7.50748L9.64254 6.13573C10.3164 5.85473 10.8153 5.67014 11.1393 5.58198C11.4631 5.49398 11.762 5.44998 12.0358 5.44998C12.4786 5.44998 12.8738 5.55939 13.2213 5.77823C13.5688 5.99706 13.8592 6.29456 14.0925 6.67073L15.1208 8.30648C15.4425 8.81664 15.854 9.25398 16.3555 9.61848C16.8569 9.98298 17.4481 10.2366 18.1293 10.3792C18.5243 10.4721 18.8585 10.6576 19.132 10.9357C19.4057 11.2141 19.5425 11.5507 19.5425 11.9457C19.5425 12.3572 19.3992 12.6974 19.1125 12.9662C18.8259 13.2351 18.4851 13.3398 18.0903 13.2805C17.1801 13.1471 16.3696 12.8987 15.6588 12.5352C14.948 12.1719 14.3295 11.7305 13.8033 11.211L13.399 13.3282L15 14.8292C15.1522 14.9814 15.2687 15.155 15.3495 15.35C15.4304 15.545 15.4708 15.7482 15.4708 15.9597V22.0467C15.4708 22.4417 15.3322 22.7778 15.055 23.055C14.7779 23.3321 14.4418 23.4707 14.0468 23.4707C13.6518 23.4707 13.3157 23.3321 13.0385 23.055C12.7614 22.7778 12.6228 22.4417 12.6228 22.0467ZM11.901 4.52398C11.4395 4.06231 11.2088 3.49831 11.2088 2.83198C11.2088 2.16564 11.4395 1.60406 11.901 1.14723C12.3627 0.690393 12.9267 0.461975 13.593 0.461975C14.2594 0.461975 14.821 0.690393 15.2778 1.14723C15.7346 1.60406 15.963 2.16564 15.963 2.83198C15.963 3.49831 15.7346 4.06231 15.2778 4.52398C14.821 4.98548 14.2594 5.21623 13.593 5.21623C12.9267 5.21623 12.3627 4.98548 11.901 4.52398Z"
                fill="currentColor"
              />
              <path
                v-if="expandedEvent.type_of_event === 'move4water'"
                d="M12.8381 13.9663L7.20884 19.5815C6.93267 19.867 6.59892 20.0098 6.20759 20.0098C5.81642 20.0098 5.48275 19.8693 5.20659 19.5885C4.93059 19.3078 4.79259 18.9742 4.79259 18.5875C4.79259 18.2008 4.93059 17.8695 5.20659 17.5935L13.3478 9.42401H11.4838V9.69351C11.4838 10.0883 11.3429 10.4244 11.0611 10.7018C10.7791 10.9789 10.443 11.1175 10.0528 11.1175C9.66267 11.1175 9.329 10.9789 9.05184 10.7018C8.7745 10.4244 8.63584 10.0883 8.63584 9.69351V8.11301C8.63584 7.68985 8.78392 7.32793 9.08009 7.02726C9.37609 6.72643 9.74034 6.57601 10.1728 6.57601H15.3608C15.7675 6.57601 16.1593 6.65451 16.5361 6.81151C16.9128 6.96835 17.2449 7.1906 17.5326 7.47826L20.3338 10.2685C20.6577 10.5923 21.0191 10.8473 21.4181 11.0333C21.8169 11.2191 22.2319 11.3537 22.6631 11.437C23.0653 11.5203 23.4073 11.7029 23.6893 11.9848C23.9712 12.2666 24.1121 12.605 24.1121 13C24.1121 13.4022 23.961 13.7383 23.6588 14.0083C23.3567 14.2781 23.0081 14.3833 22.6131 14.324C21.8464 14.2073 21.1078 14.0008 20.3973 13.7043C19.6868 13.4079 19.0436 12.967 18.4676 12.3815L17.7381 11.6663L16.1293 13.25L17.0598 14.1805C17.4142 14.5348 17.5598 14.9598 17.4968 15.4555C17.4338 15.9512 17.1824 16.3262 16.7426 16.5805L12.3196 19.1598C11.9748 19.3526 11.6155 19.3966 11.2418 19.2918C10.8683 19.1871 10.5828 18.9647 10.3853 18.6245C10.188 18.2843 10.1375 17.9251 10.2338 17.5468C10.3302 17.1684 10.5508 16.8829 10.8958 16.6903L13.8436 14.9858L12.8381 13.9663ZM3.21209 13.9653C2.81709 13.9653 2.481 13.8267 2.20384 13.5495C1.92667 13.2723 1.78809 12.9363 1.78809 12.5413C1.78809 12.1464 1.92667 11.8104 2.20384 11.5333C2.481 11.2561 2.81709 11.1175 3.21209 11.1175H6.21209C6.59759 11.1175 6.93125 11.2561 7.21309 11.5333C7.49492 11.8104 7.63584 12.1464 7.63584 12.5413C7.63584 12.9363 7.49492 13.2723 7.21309 13.5495C6.93125 13.8267 6.59759 13.9653 6.21209 13.9653H3.21209ZM1.21209 10.1175C0.817086 10.1175 0.481003 9.97893 0.203836 9.70176C-0.0733308 9.42443 -0.211914 9.09068 -0.211914 8.70051C-0.211914 8.31035 -0.0733308 7.97435 0.203836 7.69251C0.481003 7.41051 0.817086 7.26951 1.21209 7.26951H4.21209C4.59759 7.26951 4.93125 7.41051 5.21309 7.69251C5.49492 7.97435 5.63584 8.31035 5.63584 8.70051C5.63584 9.09068 5.49492 9.42443 5.21309 9.70176C4.93125 9.97893 4.59759 10.1175 4.21209 10.1175H1.21209ZM20.7523 7.94901C20.0647 7.94901 19.4869 7.7146 19.0191 7.24576C18.5514 6.77693 18.3176 6.20101 18.3176 5.51801C18.3176 4.83501 18.5514 4.26143 19.0191 3.79726C19.4869 3.3331 20.0647 3.10101 20.7523 3.10101C21.4212 3.10101 21.9942 3.33543 22.4713 3.80426C22.9485 4.2731 23.1871 4.84435 23.1871 5.51801C23.1871 6.19151 22.9485 6.76501 22.4713 7.23851C21.9942 7.71218 21.4212 7.94901 20.7523 7.94901ZM3.21209 6.26951C2.81709 6.26951 2.481 6.13093 2.20384 5.85376C1.92667 5.5766 1.78809 5.24293 1.78809 4.85276C1.78809 4.4626 1.92667 4.12651 2.20384 3.84451C2.481 3.56268 2.81709 3.42176 3.21209 3.42176H6.21209C6.59759 3.42176 6.93125 3.56268 7.21309 3.84451C7.49492 4.12651 7.63584 4.4626 7.63584 4.85276C7.63584 5.24293 7.49492 5.5766 7.21309 5.85376C6.93125 6.13093 6.59759 6.26951 6.21209 6.26951H3.21209Z"
                fill="currentColor"
              />
              <path
                v-if="
                  expandedEvent.type_of_event === 'network' ||
                  expandedEvent.type_of_event === 'crew_meeting'
                "
                d="M1.05214 18.4847C0.61947 18.4847 0.255137 18.3367 -0.0408633 18.0407C-0.336863 17.7447 -0.484863 17.379 -0.484863 16.9435V16.425C-0.484863 15.5562 -0.0694467 14.854 0.761387 14.3185C1.59205 13.783 2.67155 13.5152 3.99989 13.5152C4.04555 13.5152 4.0858 13.5129 4.12064 13.5082C4.1553 13.5034 4.20022 13.501 4.25539 13.501C3.97205 13.9272 3.75897 14.3816 3.61614 14.8642C3.47347 15.3467 3.40214 15.8503 3.40214 16.375V18.4847H1.05214ZM7.05214 18.4847C6.61947 18.4847 6.25514 18.3367 5.95914 18.0407C5.66314 17.7447 5.51514 17.3787 5.51514 16.9425V16.3842C5.51514 15.7759 5.66747 15.217 5.97214 14.7075C6.2768 14.1982 6.7208 13.7554 7.30414 13.3792C7.89697 13.0126 8.59214 12.7352 9.38964 12.5472C10.187 12.3592 11.0567 12.2652 11.9989 12.2652C12.9591 12.2652 13.8336 12.3592 14.6226 12.5472C15.4118 12.7352 16.0981 13.0126 16.6814 13.3792C17.2742 13.7554 17.723 14.1982 18.0276 14.7075C18.3323 15.217 18.4846 15.7759 18.4846 16.3842V16.9425C18.4846 17.3787 18.3366 17.7447 18.0406 18.0407C17.7446 18.3367 17.3803 18.4847 16.9476 18.4847H7.05214ZM20.5976 18.4847V16.375C20.5976 15.8335 20.5286 15.3232 20.3906 14.8442C20.2526 14.3652 20.0456 13.9175 19.7694 13.501C19.8246 13.501 19.8683 13.5034 19.9006 13.5082C19.933 13.5129 19.9661 13.5152 19.9999 13.5152C21.3454 13.5152 22.4292 13.7803 23.2514 14.3105C24.0736 14.8407 24.4846 15.5459 24.4846 16.4262V16.944C24.4846 17.3792 24.3366 17.7447 24.0406 18.0407C23.7446 18.3367 23.3803 18.4847 22.9476 18.4847H20.5976ZM8.92264 15.6792H15.1021C14.705 15.4836 14.2281 15.3309 13.6716 15.2212C13.1151 15.1114 12.5602 15.0565 12.0069 15.0565C11.4537 15.0565 10.8941 15.1132 10.3281 15.2267C9.76214 15.3401 9.29364 15.4909 8.92264 15.6792ZM4.00339 12.6292C3.37489 12.6292 2.8328 12.4052 2.37714 11.9572C1.9213 11.5091 1.69339 10.9695 1.69339 10.3385C1.69339 9.68849 1.9198 9.14132 2.37264 8.69699C2.82547 8.25266 3.3658 8.03049 3.99364 8.03049C4.64064 8.03049 5.1878 8.25066 5.63514 8.69099C6.08264 9.13149 6.30639 9.67724 6.30639 10.3282C6.30639 10.9601 6.08572 11.5016 5.64439 11.9527C5.20289 12.4037 4.65589 12.6292 4.00339 12.6292ZM20.0034 12.6292C19.3749 12.6292 18.8328 12.4052 18.3771 11.9572C17.9213 11.5091 17.6934 10.9695 17.6934 10.3385C17.6934 9.68849 17.9198 9.14132 18.3726 8.69699C18.8255 8.25266 19.3658 8.03049 19.9936 8.03049C20.6406 8.03049 21.1878 8.25066 21.6351 8.69099C22.0826 9.13149 22.3064 9.67724 22.3064 10.3282C22.3064 10.9601 22.0857 11.5016 21.6444 11.9527C21.2029 12.4037 20.6559 12.6292 20.0034 12.6292ZM11.9999 11.5402C11.0397 11.5402 10.2189 11.1995 9.53739 10.518C8.85589 9.83649 8.51514 9.01566 8.51514 8.05549C8.51514 7.07716 8.85589 6.25174 9.53739 5.57924C10.2189 4.90691 11.0397 4.57074 11.9999 4.57074C12.9782 4.57074 13.8036 4.90691 14.4759 5.57924C15.1484 6.25174 15.4846 7.07716 15.4846 8.05549C15.4846 9.01566 15.1484 9.83649 14.4759 10.518C13.8036 11.1995 12.9782 11.5402 11.9999 11.5402ZM12.0139 8.74899C12.2024 8.74899 12.3627 8.67816 12.4949 8.53649C12.6272 8.39482 12.6934 8.22974 12.6934 8.04124C12.6934 7.85291 12.6265 7.69257 12.4926 7.56024C12.359 7.42807 12.1932 7.36199 11.9954 7.36199C11.8172 7.36199 11.6579 7.42882 11.5174 7.56249C11.3767 7.69632 11.3064 7.86216 11.3064 8.05999C11.3064 8.23816 11.3772 8.39749 11.5189 8.53799C11.6606 8.67866 11.8256 8.74899 12.0139 8.74899Z"
                fill="currentColor"
              />
              <path
                v-if="expandedEvent.type_of_event === 'other'"
                d="M4.98184 14.4347C4.307 14.4347 3.731 14.1977 3.25384 13.7235C2.77667 13.2492 2.53809 12.6757 2.53809 12.003C2.53809 11.3227 2.77692 10.7463 3.25459 10.274C3.73209 9.8015 4.30617 9.56525 4.97684 9.56525C5.65534 9.56525 6.23484 9.80208 6.71534 10.2757C7.19567 10.7496 7.43584 11.3233 7.43584 11.997C7.43584 12.6773 7.19559 13.2537 6.71509 13.726C6.23459 14.1985 5.65684 14.4347 4.98184 14.4347ZM12.0031 14.4347C11.3228 14.4347 10.7464 14.1977 10.2741 13.7235C9.80159 13.2492 9.56534 12.6757 9.56534 12.003C9.56534 11.3227 9.80242 10.7463 10.2766 10.274C10.7509 9.8015 11.3244 9.56525 11.9971 9.56525C12.6774 9.56525 13.2538 9.80208 13.7261 10.2757C14.1986 10.7496 14.4348 11.3233 14.4348 11.997C14.4348 12.6773 14.198 13.2537 13.7243 13.726C13.2505 14.1985 12.6768 14.4347 12.0031 14.4347ZM19.0273 14.4347C18.3478 14.4347 17.7674 14.1977 17.2861 13.7235C16.8049 13.2492 16.5643 12.6757 16.5643 12.003C16.5643 11.3227 16.8056 10.7463 17.2881 10.274C17.7706 9.8015 18.3507 9.56525 19.0283 9.56525C19.7058 9.56525 20.2808 9.80208 20.7533 10.2757C21.2258 10.7496 21.4621 11.3233 21.4621 11.997C21.4621 12.6773 21.2252 13.2537 20.7513 13.726C20.2777 14.1985 19.703 14.4347 19.0273 14.4347Z"
                fill="currentColor"
              />
            </svg>

            <ShareIconButton
              :url="event.shareURL"
              :text="
                $t('events.share.text', {
                  0: event.name,
                })
              "
            ></ShareIconButton>
          </div>
        </vca-row>
      </div>

      <div class="meta">
        <div class="meta-row">
          <svg
            :title="$t('events.location.title')"
            xmlns="http://www.w3.org/2000/svg"
            width="24px"
            height="24px"
            viewBox="0 -960 960 960"
            fill="currentColor"
          >
            <path
              d="M480-202.7q117.61-103.74 177.28-189.1 59.68-85.37 59.68-164.33 0-102.17-68.96-172t-168-69.83q-99.04 0-168 69.83t-68.96 172q0 78.96 59.68 163.83Q362.39-307.44 480-202.7ZM442.8-79.78q-18.06-6-33.63-19.57-73.13-64.43-127.47-123.93-54.35-59.5-90.2-115.28-35.85-55.79-53.63-109.98-17.78-54.2-17.78-107.59 0-157.48 106.67-261.13T480-920.91q146.57 0 253.24 103.65 106.67 103.65 106.67 261.13 0 53.39-17.78 107.59-17.78 54.19-53.63 109.98-35.85 55.78-90.2 115.28-54.34 59.5-127.47 123.93-15.57 13.57-33.63 19.57-18.07 6-37.2 6-19.13 0-37.2-6ZM480-560Zm65.2 65.2q27.06-27.07 27.06-65.2t-27.06-65.2q-27.07-27.06-65.2-27.06t-65.2 27.06q-27.06 27.07-27.06 65.2t27.06 65.2q27.07 27.06 65.2 27.06t65.2-27.06Z"
            />
          </svg>
          <span>{{ expandedEvent.eventLocation }}</span>
        </div>
        <div class="meta-row">
          <svg
            :title="$t('events.time.event_period')"
            xmlns="http://www.w3.org/2000/svg"
            width="24px"
            height="24px"
            viewBox="0 -960 960 960"
            fill="currentColor"
          >
            <path
              d="M203.04-40.96q-51.3 0-87.12-36.22-35.83-36.23-35.83-86.73v-554.48q0-51.3 35.83-87.13 35.82-35.83 87.12-35.83H215v-23q0-22.34 16.35-38.52 16.35-16.17 39.19-16.17 22.85 0 38.63 16.17 15.79 16.18 15.79 38.52v23h310.08v-23q0-22.34 16.07-38.52 16.06-16.17 38.91-16.17 22.85 0 38.91 16.17Q745-886.69 745-864.35v23h11.96q51.3 0 87.12 35.83 35.83 35.83 35.83 87.13v554.48q0 50.5-35.83 86.73-35.82 36.22-87.12 36.22H203.04Zm0-122.95h553.92v-409.31H203.04v409.31Zm0-506.26h553.92v-48.22H203.04v48.22Zm0 0v-48.22 48.22Zm277.24 278.43q-20.08 0-34.31-14.23-14.23-14.23-14.23-33.91 0-19.69 14.23-34.03 14.23-14.35 34.31-14.35 20.08 0 34.03 14.23 13.95 14.23 13.95 33.91 0 19.69-13.95 34.03-13.95 14.35-34.03 14.35Zm-194.19-14.23q-14.35-14.23-14.35-33.91 0-19.69 14.23-34.03 14.23-14.35 33.91-14.35 19.69 0 34.03 14.23 14.35 14.23 14.35 33.91 0 19.69-14.23 34.03-14.23 14.35-33.91 14.35-19.69 0-34.03-14.23Zm353.63 14.23q-19.29 0-33.63-14.23-14.35-14.23-14.35-33.91 0-19.69 14.35-34.03 14.34-14.35 33.91-14.35 19.58 0 33.92 14.23 14.34 14.23 14.34 33.91 0 19.69-14.23 34.03-14.23 14.35-34.31 14.35Zm-159.44 160q-20.08 0-34.31-14.35-14.23-14.34-14.23-33.91 0-19.58 14.23-33.92 14.23-14.34 34.31-14.34 20.08 0 34.03 14.23 13.95 14.23 13.95 34.31 0 19.29-13.95 33.63-13.95 14.35-34.03 14.35Zm-194.19-14.35q-14.35-14.34-14.35-33.91 0-19.58 14.23-33.92 14.23-14.34 33.91-14.34 19.69 0 34.03 14.23 14.35 14.23 14.35 34.31 0 19.29-14.23 33.63-14.23 14.35-33.91 14.35-19.69 0-34.03-14.35Zm353.63 14.35q-19.29 0-33.63-14.35-14.35-14.34-14.35-33.91 0-19.58 14.35-33.92 14.34-14.34 33.91-14.34 19.58 0 33.92 14.23 14.34 14.23 14.34 34.31 0 19.29-14.23 33.63-14.23 14.35-34.31 14.35Z"
            />
          </svg>
          <span>{{ eventPeriod }}</span>
        </div>
        <div class="meta-row">
          <svg
            :title="$t('events.crew.label')"
            xmlns="http://www.w3.org/2000/svg"
            width="24px"
            height="24px"
            viewBox="0 -960 960 960"
            fill="currentColor"
          >
            <path
              d="M42.09-220.61q-25.96 0-43.72-17.76-17.76-17.76-17.76-43.89V-303q0-52.13 49.85-84.26Q80.3-419.39 160-419.39q2.74 0 4.83-.28 2.08-.29 5.39-.29-17 25.57-25.57 54.53-8.56 28.95-8.56 60.43v84.39h-94Zm240 0q-25.96 0-43.72-17.76-17.76-17.76-17.76-43.93v-22.33q0-36.5 18.28-67.07 18.28-30.56 53.28-53.13 35.57-22 83.42-33.28 47.84-11.28 104.37-11.28 57.61 0 104.95 11.28 47.35 11.28 82.35 33.28 35.57 22.57 53.85 53.13 18.28 30.57 18.28 67.07v22.33q0 26.17-17.76 43.93-17.76 17.76-43.72 17.76H282.09Zm541.82 0V-305q0-32.49-8.28-61.23-8.28-28.74-24.85-53.73 3.31 0 5.25.29 1.94.28 3.97.28 80.73 0 130.06 31.81t49.33 84.63v20.71q0 26.11-17.76 43.87-17.76 17.76-43.72 17.76h-94Zm-467-112.22h247.18q-23.83-11.74-57.22-18.32-33.39-6.59-66.59-6.59-33.19 0-67.15 6.81-33.96 6.8-56.22 18.1Zm-196.77-122q-37.71 0-65.05-26.88-27.35-26.89-27.35-64.75 0-39 27.17-65.66 27.17-26.66 64.84-26.66 38.82 0 65.66 26.42 26.85 26.43 26.85 65.49 0 37.91-26.48 64.98-26.49 27.06-65.64 27.06Zm640 0q-37.71 0-65.05-26.88-27.35-26.89-27.35-64.75 0-39 27.17-65.66 27.17-26.66 64.84-26.66 38.82 0 65.66 26.42 26.85 26.43 26.85 65.49 0 37.91-26.48 64.98-26.49 27.06-65.64 27.06ZM480-498.39q-57.61 0-98.5-40.89t-40.89-98.5q0-58.7 40.89-99.05 40.89-40.34 98.5-40.34 58.7 0 99.04 40.34 40.35 40.35 40.35 99.05 0 57.61-40.35 98.5-40.34 40.89-99.04 40.89Zm.56-111.65q11.31 0 19.24-8.5 7.94-8.5 7.94-19.81 0-11.3-8.03-19.24-8.02-7.93-19.89-7.93-10.69 0-19.12 8.02-8.44 8.03-8.44 19.9 0 10.69 8.5 19.12 8.5 8.44 19.8 8.44Zm.44 277.21Zm-1-304.95Z"
            />
          </svg>
          <span v-if="event.crew.name != ''">{{
            expandedEvent.eventCrew
          }}</span>
        </div>
        <div v-if="canView" class="meta-row">
          <svg
            :title="$t('events.informations.applications')"
            xmlns="http://www.w3.org/2000/svg"
            width="24px"
            height="24px"
            viewBox="0 -960 960 960"
            fill="currentColor"
          >
            <path
              d="M308.49-74.69q-79.98-34.61-139.58-94.22-59.61-59.6-94.22-139.58-34.6-79.99-34.6-171.35 0-91.37 34.56-171.52 34.57-80.16 94.19-139.76 59.62-59.59 139.85-94.19 80.22-34.6 171.31-34.6 25.35 0 43.41 18.06 18.07 18.06 18.07 43.42 0 25.35-18.07 43.41-18.06 18.06-43.41 18.06-132.05 0-224.5 92.46-92.46 92.45-92.46 224.49 0 132.05 92.46 224.51 92.45 92.46 224.49 92.46 132.05 0 224.51-92.46 92.46-92.45 92.46-224.5 0-25.35 18.06-43.41 18.06-18.07 43.41-18.07 25.36 0 43.42 18.07 18.06 18.06 18.06 43.41 0 91.09-34.6 171.31-34.6 80.23-94.19 139.85-59.6 59.62-139.76 94.19-80.15 34.56-171.52 34.56-91.36 0-171.35-34.6Z"
            />
          </svg>
          <span>{{
            expandedEvent.applications_total +
            (expandedEvent.type_of_event !== "crew_meeting"
              ? "/" + expandedEvent.supporter_count
              : "")
          }}</span>
        </div>
      </div>

      <div class="vca-center">
        <button
          class="vca-new-button"
          :title="buttonLabel(event)"
          @click="setCurrent(event)"
        >
          {{ this.buttonLabel(event) }}
        </button>
        <button
          v-if="canEdit || (isUserEditable && isEventAsp(event))"
          :title="$t('button.edit')"
          class="vca-new-button"
          @click="setCurrentEdit(event)"
        >
          {{ $t("button.edit") }}
        </button>
      </div>
    </vca-column>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ShareIconButton from "@/components/utils/ShareIconButton.vue";

export default {
  name: "EventCard",
  components: {
    ShareIconButton,
  },
  props: {
    event: {
      type: Object,
      default: null,
    },
  },
  computed: {
    isUserEditable() {
      return (
        this.event.event_state.state !== "closed" &&
        this.event.event_state.state !== "finished"
      );
    },
    canEdit() {
      return (
        this.hasSystemPermission() ||
        (this.isUserEditable &&
          this.hasPoolPermission(this.poolEventPermissions) &&
          this.user.crew.crew_id === this.event.crew.id)
      );
    },
    canView() {
      return (
        this.hasSystemPermission() ||
        this.hasPoolPermission(this.poolEventPermissions) ||
        this.hasPoolPermission("socialmedia")
      );
    },
    eventPeriod() {
      return this.datetime(this.event.start_at);
    },
    expandedEvent() {
      let row = {};
      row["shareURL"] = "/events/" + this.event.id;
      row["eventArtists"] =
        this.event.artists && this.event.artists.length > 0
          ? this.event.artists.map((el) => el.name).join(", ")
          : " - ";
      row["eventLocation"] = this.event.location.name
        ? this.event.location.name +
          (this.event.location.name
            .toLowerCase()
            .includes(this.event.location.city.toLowerCase())
            ? ""
            : ", " + this.event.location.city)
        : " - ";
      row["eventWebsite"] = this.event.website ? this.event.website : " - ";
      row["isPublished"] = this.publishedStates.includes(
        this.event.event_state.state
      );

      let mappedState = this.event.event_state.state;
      if (this.event.event_state.state == "requested") {
        mappedState =
          this.event.event_state.crew_confirmation == ""
            ? "requested_crew"
            : "requested_internal";
      }
      row["mappedState"] = mappedState;
      row["event_state_text"] = this.$t(
        "events.list.event_states." + mappedState
      );
      if (
        this.hasSystemPermission() &&
        this.event.event_state.state == "closed"
      ) {
        row["event_state_text"] = this.$t("events.list.event_states.closed");
      }
      row["type_of_event_translation"] = this.$t(
        "events.eventtypes." + this.event.type_of_event + ".label"
      );

      if (this.event.event_state.state === "created") {
        row["type_of_event_translation"] += this.$t(
          "events.list.event_states.created_appendix"
        );
      }

      if (this.event.event_state.state == "requested") {
        row["event_state_text"] =
          this.event.event_state.internal_confirmation == ""
            ? this.$t("events.list.event_states.requested_internal")
            : this.$t("events.list.event_states.requested_crew");
      }
      row["eventCrew"] =
        this.event.crew && this.event.crew.name != ""
          ? this.event.crew.name
          : this.event.organisation.abbreviation;

      row["supporter_count"] = this.event.application.supporter_count;
      row["applications_total"] = this.event.applications
        ? this.event.applications.total
        : 0;

      return {
        ...this.event,
        ...row,
      };
    },
    ...mapGetters({
      user: "user/current",
      publishedStates: "events/publishedstates",
      pool: "user/roles/pool",
      hasPoolPermission: "user/roles/hasPoolPermission",
      poolEventPermissions: "user/roles/poolEventPermissions",
      hasSystemPermission: "user/roles/hasSystemPermission",
    }),
  },
  methods: {
    isEventAsp(value) {
      return (
        this.user && value.event_asp_id && this.user.id == value.event_asp_id
      );
    },
    setCurrent(value) {
      if (this.current && this.current.id === value.id) {
        this.$store.commit("events/current", null);
      } else {
        this.$store.commit("events/current", value);
      }
      window.history.replaceState({}, "", "/events/" + value.id);
    },
    setCurrentEdit(value) {
      this.$router.push({ path: "/events/edit/" + value.id });
    },
    buttonLabel(event) {
      if (event.event_state.state === "created") {
        return this.$t("button.show_draft");
      }
      return this.$t("button.join");
    },
  },
};
</script>

<style lang="scss" scoped>
.event-card {
  padding: 16px;
}

.event-title {
  margin-bottom: 16px;
}

.event-subtitle {
  margin: 0 !important;
  font-size: 14px;
}

.top-row {
  flex-wrap: nowrap;
  gap: 1em;
}

.title {
  font-size: 22px;
  line-height: 1.2;

  @include media(large) {
    font-size: 26px;
  }
}

.top-row-meta {
  flex-basis: auto;
}

.meta {
  display: flex;
  flex-direction: column;
  gap: 0.5em;
  margin-block: 8px;
}

.meta-row {
  display: flex;
  flex-wrap: nowrap;
  gap: 0.7em;
  align-items: center;

  svg {
    flex-shrink: 0;
  }
}
</style>
